export function generateBuyerDashboardUrl(
  whiteLabel: string,
  subdomain?: string
): string {
  const label = whiteLabel || subdomain || "";
  const rootDomain = process.env["NEXT_PUBLIC_ROOT_DOMAIN"] || "";

  const isDev = process.env.NODE_ENV === "development";
  return isDev
    ? `http://${label}.lvh.me:3000/buyer-dashboard/events`
    : `https://${label}.${rootDomain}/buyer-dashboard/events`;
}
